import React, { useEffect, useState } from 'react';

//Import components
import Questionnaire from '../questionnaires/Questionnaire';
import ResultPage from '../resultpage/ResultPage';

//Import utils
import { config as Config } from "../../config/config";
import Papa from 'papaparse';

//translation
import { useTranslation } from "react-i18next";

export default function Container(props) {

    const [questionnaireFinished, setQuestionnarieFinised] = useState(false);
    const [displayResults, _setDisplayResults] = useState(false);
    const [resultsData, setResultsData] = useState([]);
    const [linksData, setLinksData] = useState([]);
    const [product, setProduct] = useState([]);
    const [answers, setAnswers] = useState({});
    const [currentQuestion, setCurrentQuestion] = useState(1);
    const [nextPossibleAnswers, setNextPossibleAnswers] = useState([]);

    const [allProductTypes, setAllProductTypes] = useState({});
    const [t, i18n] = useTranslation('common');

    useEffect(() => {
        getResultsData();
        getLinksData();
    }, []);

    useEffect(() => {
        let filteredProducts = []
        //filter csv according to the answers
        filteredProducts = filterCSV(answers);

        if(filteredProducts.length) {
            setProduct(filteredProducts);
        }

    }, [answers]);

    function filterProductsForQuestion(question) {
        const filtered = Object.keys(answers).filter(key => key < question).reduce((obj, key) => {
            obj[key] = answers[key]; 
            return obj;
        }, {});
        return filterCSV(filtered)
    }


    function filterCSV(answers) {
        let filtered =  resultsData.filter(row => {

            let found = Object.keys(answers).map(x => 0);

            Object.entries(answers).filter(([key, answer]) => answer !== "").forEach(([key, answer]) => {
                found[key - 1] = row[`answer_${key}`].toLowerCase() === answer.toLowerCase();
            });
            return !found.includes(false);
        });
        return filtered
    }


    useEffect(() => {
        let uniques = []
        if(currentQuestion <= Object.keys(answers).length) {
            const filtered = Object.keys(answers).filter(key => key < currentQuestion).reduce((obj, key) => {
                obj[key] = answers[key];
                return obj;
            }, {});

            uniques = [...new Set(filterCSV(filtered).map(item => item[`answer_${currentQuestion}`].toLowerCase()))];
            setNextPossibleAnswers(uniques)
        }else {
            uniques = [...new Set(product.map(item => item[`answer_${currentQuestion}`].toLowerCase()))];
            setNextPossibleAnswers(uniques)
        }

    }, [currentQuestion, answers])

    useEffect(() => {
        if(currentQuestion === Config.totalquestion && answers.hasOwnProperty(Config.totalquestion) && !questionnaireFinished) {
            setQuestionnarieFinised(true);
        }
    }, [product]);


    function setupProduct() {
        setProduct(product.shift());
        _setDisplayResults(true)
    }

    function getProductTypes(data) {
        let temp = {};
        data.forEach(prod => {
            temp[prod.product_ean] =
            {
                detail:prod.product_shade_description,
                code:prod.product_shade
            }

        });
        setAllProductTypes(temp);
    }

    function handleResultsData(result) {
        if(!resultsData.length) {
            getProductTypes(result.data)
            setResultsData(result.data)
        }
    }

    function handleLinksData(links) {
        if(!linksData.length) {
            setLinksData(links.data)
        }
    }

    async function getResultsData() {
        Papa.parse(Config.data, {
            delimiter: ',',
            quoteChar: '"',
            download: true,
            header: true,
            complete: handleResultsData
        });

    }

    async function getLinksData() {
        Papa.parse(Config.links, {
            download: true,
            header: true,
            complete: handleLinksData
        });

    }

    function resetQuestionnarie() {
        setQuestionnarieFinised(false);
        setAnswers({});
        setProduct([]);
        setCurrentQuestion(1);
        setNextPossibleAnswers([]);
    }

    function changeLanguage(language) {
        i18n.changeLanguage(language);
    }

    function languageSwithcer() {
        if(Config.languages.length > 1) {
            return(
                <select name="languages" id="languages" onChange={(evt) => changeLanguage(evt.target.value)}>
                    {Config.languages.map(language => {
                        return(<option value={language}>{language}</option>);
                    })}
                </select>  
            );
        }
    }
 
    return(
        <div className="main-container" style={{width:Config.container.width, height:Config.container.height}}>
            <div className="language-switcher">
                {languageSwithcer()}
            </div>
            <div className="logo-wrapper">
                <div className="logo">
                    <img src={process.env.PUBLIC_URL + '/images/huda.svg'} />
                </div>
            </div>
            {!displayResults ?
                <Questionnaire 
                    answers={answers} 
                    setAnswers={setAnswers} 
                    currentQuestion={currentQuestion} 
                    setCurrentQuestion={setCurrentQuestion}
                    nextPossibleAnswers={nextPossibleAnswers}
                    allProductTypes={allProductTypes}
                    product={product}
                    filterProductsForQuestion={filterProductsForQuestion}
                    setDisplayResults={setupProduct}
                    questionnaireFinished={questionnaireFinished}
                />
            :
                <ResultPage product={product} resetQuestionnarie={resetQuestionnarie} links={linksData} type={answers[1] === "Full Coverage" ? "foundation-liquid" : answers[1] === "Buildable Coverage" ? "foundation-stick" : "huda"} setDisplayResults={_setDisplayResults}/>
            }
        </div>
    );
}
